import React from "react";
import { useSelector } from "react-redux";
import { selectors } from "reducers/patient-outreaches";

const PoolRules = () => {
  const rules = useSelector(selectors.getEligibilityRules);
  if (!rules || rules.length === 0) return null;

  return (
    <details className="pool-rules">
      <summary>
        Eligibility rules ({rules.length}) — what makes a patient eligible for
        today&apos;s outreach pool
      </summary>
      <ol>
        {rules.map(rule => (
          <li key={rule.code}>
            <strong>{rule.displayName}</strong>
            <p>{rule.description}</p>
            {rule.sourceField && (
              <small className="pool-rules__source-field">
                {rule.sourceField}
              </small>
            )}
          </li>
        ))}
      </ol>
    </details>
  );
};

export default PoolRules;
